export default __webpack_public_path__ + "static/media/FeverInTheOceans_02.870a3d26.png";